<mat-card class="mb-3">
  <mat-card-content>
    <form [formGroup]="smartSearchForm" ngxsForm="{{formPath}}" [ngxsFormDebounce]="500" [ngxsFormClearOnDestroy]="formClearOnDestroy">
      <div class="row mt-3" formArrayName="searchCriteria">
        <div class="col-9">
          @for (searchItem of searchCriteria.controls; track searchItem) {
          <div class="row" [formGroupName]="$index">
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'ml_143920' | translate}}</mat-label>
                <mat-select formControlName="searchBy" (selectionChange)="searchByChanged($event, true, $index)">
                  @for (item of searchByList; track item) {
                  <mat-option [value]="item.searchBy">
                    {{item.searchByLabel| translate}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col">
              @switch (currentSearchByItemList[$index]?.searchByType) {
              @case (smartSearchType.singleSelect) {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ ('ml_143921' | translate)}}</mat-label>
                <mat-select formControlName="searchValue">
                  @for (item of currentSearchByItemList[$index].searchDropDownValue; track item) {
                  <mat-option [value]="item.value">
                    {{item.label | translate}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              }
              @case (smartSearchType.multipleSelect) {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ ('ml_143921' | translate)}}</mat-label>
                <mat-select formControlName="searchValue" multiple>
                  @for (item of currentSearchByItemList[$index].searchDropDownValue; track item) {
                  <mat-option [value]="item.value">
                    {{item.label | translate}}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              }
              <!-- @case(smartSearchType.yearMonthSelct) {
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ ('ml_143921' | translate)}}</mat-label>
            <input matInput [matDatepicker]="yearMonth" formControlName="searchValue" />
            <mat-hint>MM/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="yearMonth"></mat-datepicker-toggle>
            <mat-datepicker #yearMonth startView="multi-year" (monthSelected)="setMonthAndYear($event, yearMonth, 'searchValue')">
            </mat-datepicker>
          </mat-form-field>
          } -->
              @case(smartSearchType.dateRangeSelct) {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ ('ml_143921' | translate)}}</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate placeholder="{{'ml_143966' | translate}}" formControlName="searchValueStart">
                  <input matEndDate placeholder="{{'ml_143967' | translate}}" formControlName="searchValueEnd">
                </mat-date-range-input>
                <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
              }
              @default {
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ ('ml_143921' | translate)}}</mat-label>
                <input matInput placeholder="" formControlName="searchValue" />
              </mat-form-field>
              }
              }
            </div>

            @if($index===0 && !noMoreFilter){
            <div class="col-1">
              <button mat-icon-button class="more-filter mt-1" (click)="onMoreFilter()"> + </button>
            </div>
            }
            @else if(!noMoreFilter) {
            <div class="col-1">
              <span class="close fat mt-3" (click)="onDeleteFilter($index)"></span>
            </div>
            }
          </div>
          }
        </div>

        <div class="col-3">
          <spinner-button class="float-end" [refreshState$]="searching$" [disabled]="smartSearchForm.invalid" label="{{ 'ml_143922' | translate }}" refreshLabel="{{ 'ml_143923' | translate }}"
            (clicked)="onSearch()">
          </spinner-button>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
